import { render } from "./SkeletonMoment.vue?vue&type=template&id=53d22ef4"
import script from "./SkeletonMoment.vue?vue&type=script&lang=js"
export * from "./SkeletonMoment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__